<template>
  <div class="mycourse">
    <Row class="top-title"
         type="flex"
         justify="space-between"
         align="bottom">
      <i-col span="8"
             class="title-left">
        <span>我的课程</span>
        <router-link to="/mymenu">我的首页</router-link>
      </i-col>
      <i-col span="7">
      </i-col>
      <i-col span="4"
             class="title-right">
        <span @click="back">返回课程地图</span>
      </i-col>
      <i-col span="1">
      </i-col>
    </Row>
    <div class="course-tip">
      <p class="course-name">{{unit.unitName}}</p>
      <Row type="flex"
           align="middle"
           justify="space-between">
        <i-col span="16">
          <p class="tip"
             v-if="false">你已完成 50% 的课程进度，离“小小工程师”更近一步了，加油哦！</p>
        </i-col>
        <i-col span="8"
               class="check-btn">
          <span v-if="prevId" @click="viewUnit(prevId)">上一节 <svg-icon icon-class="pre"></svg-icon>
          </span>
          <span v-if="lastId" @click="viewUnit(lastId)">下一节 <svg-icon icon-class="next"></svg-icon>
          </span>
        </i-col>
      </Row>
    </div>
    <Row>
      <i-col span="17">
        <div class="ext-code" v-if="getCoursewareByType(1).extCode" v-html="getCoursewareByType(1).extCode">

        </div>
        <video v-else :src="getCoursewareByType(1).mediaFileUrl"
               controls="true"
               autoplay="true"></video>
      </i-col>
      <i-col span="5"
             class="right-content">
        <p>课程内容</p>
        <ul>
          <li v-if="getCoursewareByType(2)">
            <svg-icon icon-class="a1"></svg-icon>
            <span><a :href="getCoursewareByType(2).mediaFileUrl"
                 target="_blank">本节知识点</a></span>
          </li>
          <li v-if="getCoursewareByType(3)"> 
            <svg-icon icon-class="a1"></svg-icon>
            <span><a :href="getCoursewareByType(3).mediaFileUrl"
                 target="_blank">课堂练习</a></span>
          </li>
          <li v-if="getCoursewareByType(4)">
            <svg-icon icon-class="a2"></svg-icon>
            <span><a :href="getCoursewareByType(4).mediaFileUrl"
                 target="_blank">今日任务</a></span>
          </li>
          <li v-if="getCoursewareByType(6)">
            <svg-icon icon-class="a1"></svg-icon>
            <span><a :href="getCoursewareByType(6).mediaFileUrl"
                 target="_blank">代码资料</a></span>
          </li>
        </ul>
        <div class="submit" v-if="getCoursewareByType(5)">
          <span><a :href="'/static/scratch3/index.html?scene=course&unitId='+this.unitId + '&mediaId=' +getCoursewareByType(5).id"
               target="_blank">提交作业</a></span>
        </div>
      </i-col>
    </Row>
  </div>
</template>
<script>
import { getCourseCourseware,getCourseUnit } from "@/api/course";
import { removeToken, removeUserInfo } from "@/utils/auth";
export default {
  data () {
    return {
      type: "0",
      unitId: '',
      unit: {},
      courseId:'',
       departId: "",
      prevId: '',
      lastId:'',
      coursewareResult: []
    };
  },
  created () {
    // this.getMineCourse(1, 99);
    // this.getMineReview();
    this.unitId = this.$route.query.unitId
    this.getCourseCourseware()
    this.courseId = this.$route.query.courseId;
    this.departId = this.$route.query.departId;
    this.getCourseUnit();
  },
  methods: {
    getCourseCourseware () {
      getCourseCourseware(this.unitId).then(res => {
        if (res.success) {
          this.coursewareResult = res.result;
        }
      });
    },
    getCoursewareByType (type) {
      for (var i = 0; i < this.coursewareResult.length; i++) {
        if (this.coursewareResult[i].mediaType == type) {
          return this.coursewareResult[i]
        }
      }
      return false
    },
    getCourseUnit () {
      let self = this
      getCourseUnit(this.departId, this.courseId, 1, 99).then(res => {
        if (res.success) {
           res.result.records.forEach(u => {
             if(u.id == self.unitId){
               self.unit = u
               self.prevId = u.prevId
               self.lastId = u.lastId
             }
           });;
        }
      });
    },
    viewUnit (id) {
      window.location.href = `/attendclass?unitId=${id}&courseId=${this.courseId}&departId=${this.departId}`
      //window.location.reload()
    },
    back(){
      this.$router.push("/myunit?courseId="+this.courseId + "&departId=" + this.departId)
    }
  }
};
</script>
<style lang="scss">
</style>
<style lang="scss" scoped>
.mycourse {
  width: 1400px;
  margin: 0 auto;
  .top-title {
    width: 1360px;
    margin: 40px auto 80px;
    .title-left {
      color: #fff;
      span {
        font-weight: 700;
        margin-right: 50px;
        font-size: 30px;
      }
      a {
        font-weight: 700;
        font-size: 20px;
        background: rgb(57, 165, 239);
        display: inline-block;
        border-radius: 30px;
        line-height: 30px;
        padding: 5px 36px;
      }
    }
    .title-right {
      font-size: 20px;
      color: #192648;
      border-radius: 30px;
      background: #fff;
      line-height: 40px;
      padding: 0px 36px;
      height: 40px;
      cursor: pointer;
      &:hover{
        background: #f5c54a;
        color: #fff;
      }
    }
  }
  video {
    width: 940px;
    height: 532px;
    background: #fff;
    margin: 0;
    padding: 0;
  }
  .ext-code {
    width: 1000px;
    height: 600px;
    background: transparent;
    margin: 0;
    padding: 0;
  }
  .course-tip {
    text-align: left;
    margin-top: 50px;
    margin-bottom: 20px;
    width: 1083px;
    p {
      &.course-name {
        letter-spacing: 2px;
        color: #fff;
        text-indent: 70px;
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 50px;
      }
      &.tip {
        letter-spacing: 2px;
        color: #fff;
        text-indent: 80px;
        font-size: 16px;
      }
    }
    .check-btn {
      color: #fff;
      font-size: 20px;
      font-weight: 700;
      span {
        display: inline-block;
        border: 1px solid #fff;
        border-radius: 42px;
        padding: 0 20px;
        height: 42px;
        line-height: 42px;
        cursor: pointer;
        &:first-child {
          margin-right: 50px;
        }
      }
    }
  }
  .right-content {
    a {
      color: #000!important;
    }
    background: #fff;
    border-radius: 10px;
    padding: 30px;
    width: 266px;

    p {
      color: #2d2d2d;
      font-weight: 700;
      font-size: 25px;
      padding-top: 26px;
      padding-bottom: 42px;
      text-align: center;
      border-bottom: 1px solid #e9e9e9;
    }
    ul {
      height: 300px;
      margin-top: 20px;
      li {
        text-align: left;
        line-height: 51px;
        font-size: 20px;
        color: #2d2d2d;
        padding-left: 35px;
        svg {
          width: 22px;
          height: 20px;
          margin-right: 20px;
        }
      }
    }
    .submit {
      text-align: center;
      span {
        width: 192px;
        height: 44px;
        background-color: rgba(245, 154, 35, 1);
        border-radius: 44px;
        display: inline-block;
        color: #fff;
        font-size: 20px;
        text-align: center;
        line-height: 44px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/my/attendclass.vue